/* eslint-disable jsx-a11y/anchor-is-valid */
import styles from "./Search.module.scss";
import api from "../../api";
import { Fragment, useEffect, useState } from "react";

import  "../../assets/css/libraries.css";
import  "../../assets/css/style.css";
import  "../../assets/images/logo/logo-light-small.png";
//import  "../../assets/js/jquery-3.5.1.min.js";
//import jQuery from 'jquery'
// import  "../../assets/js/plugins.js";
// import  "../../assets/js/main.js";
import {Helmet} from "react-helmet";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import MainCarousel from "../../components/Landing/MainCarousel";
import NavLogo from "../../assets/images/logo/NavLogo.png";
import NavLogoFooter from "../../assets/images/logo/NavLogoFooter.png";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Rating from "@mui/material/Rating";
import Link from "@mui/material/Link";
import { Navbar } from "react-bootstrap";

function Search({ searchText, setSearchText }) {
  const { search: searchString } = useLocation();
  const parsedSearchText = searchString.replace("?", "").replaceAll("%20", " ");
  const [open, setOpen] = useState(0);
  // const [search, setSearch] = useState(searchText || parsedSearchText);
  const [finalSearch, setFinalSearch] = useState(searchText || parsedSearchText);
  const [isLoading, setIsLoading] = useState(false);
  const [doctorsSearchResults, setDoctorsSearchResults] = useState([]);
  const [centersSearchResults, setCentersSearchResults] = useState([]);

  async function getSearchResult() {
    setIsLoading(true);
    try {
      const res = await api.get(`/search?query=${finalSearch}`);
      if (res.data.model === "doctor") {
        setDoctorsSearchResults(res.data.results);
        setCentersSearchResults([]);
      } else {
        setCentersSearchResults(res.data.results);
        setDoctorsSearchResults([]);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    setSearchText(finalSearch || "");
  }, []);

  useEffect(() => {
    setFinalSearch(searchText || parsedSearchText);
    getSearchResult();
  }, [searchText]);

  
  return (
    <div className="wrapper">
   {/*  <div className="preloader">
      <div className="loading"><span></span><span></span><span></span><span></span></div>
    </div><!-- /.preloader  --> */}

    {/* <!-- =========================
        Header
    ===========================  --> */}
    <Navbar/>
    <section className="content">
          <header className="content-header-container">
            <div className="content-header-left">
              <p className="content-header-greeting">
                Welcome, &nbsp;
                <span className="content-header-user">Dr. Samanta!</span>
              </p>
            </div>
            <div className="content-header-right">
              <Breadcrumbs aria-label="breadcrumb" className="bread-crumb">
                <Link className="bread-crumb" href="/">
                  Home
                </Link>
                <Link className="bread-crumb" href="#">
                  Doctor
                </Link>
              </Breadcrumbs>
              {/* <div className="content-header-input-container">
                <input
                  type="text"
                  className="content-header-input"
                  placeholder="Type here to search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onBlur={() => setFinalSearch(search)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setFinalSearch(() => search);
                    }
                  }}
                />
                <img src={divider} alt="divider" height="20" />
                <button
                  type="submit"
                  className="content-header-input-submit"
                  onClick={() => getSearchResult()}
                >
                  <img src={searchIcon} alt="" />
                </button>
              </div>
              <button>
                <img
                  src={notificationBell}
                  alt="notification icon"
                  height="30"
                />
              </button>
              <button>
                <img src={userIcon} alt="user icon" height="30" />
              </button> */}
            </div>
          </header>
          <MainCarousel type="patient" setSearchText={setSearchText} />
          {/* <div className={styles["tab-container"]}>
            <button
              className={
                styles[`tab-button${tab === "doctors" ? "-active" : ""}`]
              }
            >
              Doctors
            </button>
            <button
              className={
                styles[`tab-button${tab === "centers" ? "-active" : ""}`]
              }
            >
              Centers
            </button>
          </div> */}

          <>
            {isLoading ? (
              <div className={styles["container"]}>
                {[...new Array(3)].map((_, i) => (
                  <div className={styles["card"]} key={i}>
                    <div className={`${styles["card-col-name"]} ${styles["skeleton"]}`}></div>
                    <div className={`${styles["card-col-info"]} ${styles["skeleton"]}`}></div>
                    <div className={`${styles["card-col"]} ${styles["skeleton"]}`}></div>
                    <div className={`${styles["card-col"]} ${styles["skeleton"]}`}></div>
                    <div className={`${styles["card-col"]} ${styles["skeleton"]}`}></div>
                  </div>
                ))}
              </div>
            ) : doctorsSearchResults.length === 0 && centersSearchResults.length === 0 ? (
              <div>
                <h1>Sorry, we couldn't find results matching "{finalSearch}"</h1>
                <p>
                  <b>Search help:</b>
                </p>
                <ul>
                  <li>Check for spelling errors in search</li>
                  <li>Use more generic search query</li>
                  <li>Try removing location</li>
                </ul>
              </div>
            ) : (
              <>
                <h1>Search Results</h1>
                <div className={styles["container"]}>
                  {doctorsSearchResults.map((result) => (
                    <div className={styles["card"]} key={result._id}>
                      <p className={styles["card-col-name"]}>{result.name}</p>
                      <p className={styles["card-col-info"]}>
                        <span>{result.email}</span>
                        <span>{result.phone}</span>
                      </p>
                      <p className={styles["card-col"]}>
                        <b>Specializations: </b>
                        {result.specializations.length !== 0 ? result.specializations.join(", ") : "Not known"}
                      </p>
                      <p className={styles["card-col"]}>
                        <b>Departments: </b>
                        {result.departments.length !== 0 ? result.departments.join(", ") : "Not known"}
                      </p>
                      <p className={styles["card-col-rating"]}>
                        <b>Rating: </b> <Rating name="read-only" value={Math.random() * 5 + 1} readOnly />
                      </p>
                      <button className={styles["schedule-appointment-button"]}>Schedule Appointment</button>
                    </div>
                  ))}
                  {centersSearchResults.map((result) => (
                    <div className={styles["card"]} key={result._id}>
                      <p className={styles["card-col-name"]}>{result.name}</p>
                      <p className={styles["card-col-info"]}>
                        <span>{result.type_text}</span>
                        <span>{result.address}</span>
                      </p>
                      <p className={styles["card-col"]}>
                        <b>Specialities: </b>
                        {result.specialities.length !== 0
                          ? result.specialities.map((item) => <Fragment key={item._id}>{item.name}, </Fragment>)
                          : "Not known"}
                      </p>
                      <p className={styles["card-col"]}>
                        <b>Visiting Doctors: </b>
                        {result.visiting_doctors.length !== 0
                          ? result.visiting_doctors.map((item) => <Fragment key={item._id}>{item.name}, </Fragment>)
                          : "Not known"}
                      </p>
                      <p className={styles["card-col"]}>
                        <b>Lab Tests: </b>
                        {result.lab_tests.length !== 0
                          ? result.lab_tests.map((item) => <Fragment key={item._id}>{item.name}, </Fragment>)
                          : "Not known"}
                      </p>
                      <button className={styles["schedule-appointment-button"]}>Schedule Appointment</button>
                    </div>
                  ))}
                </div>
              </>
            )}
          </>
        </section>
    
    {/* <!-- ============================
        contact info
    ==============================  --> */}
    

    

    {/* <!-- ========================= 
      Testimonials Removed
      =========================   --> */}

    {/* <!-- ========================
       gallery removed
      ===========================  --> */}

    {/* <!-- ==========================
        contact layout 3
    ===========================  --> */}
    <section className="contact-layout3 bg-overlay bg-overlay-primary-gradient pb-60">
      {/* <div className="bg-img"><img src="../../assets/images/banners/3.jpg" alt="banner"/></div> */}
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-7">
            <div className="contact-panel mb-50">
              <form className="contact-panel__form" method="post" action="assets/php/contact.php" id="contactForm">
                <div className="row">
                  <div className="col-sm-12">
                    <h4 className="contact-panel__title">Book An Appointment</h4>
                    <p className="contact-panel__desc mb-30">Please feel welcome to contact our friendly reception staff
                      with any general or medical enquiry. Our doctors will receive or return any urgent calls.
                    </p>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <i className="icon-widget form-group-icon"></i>
                      <select className="form-control">
                        <option value="0">Choose Clinic</option>
                        <option value="1">Pathology Clinic</option>
                        <option value="2">Dermatology Clinic</option>
                      </select>
                    </div>
                  </div>{/* <!-- /.col-lg-6  --> */}
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <i className="icon-user form-group-icon"></i>
                      <select className="form-control">
                        <option value="0">Choose Doctor</option>
                        <option value="1">Rakshit Pulluguartha</option>
                        <option value="2">Indrani Bagchi</option>
                      </select>
                    </div>
                  </div>{/* <!-- /.col-lg-6  --> */}
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <i className="icon-news form-group-icon"></i>
                      <input type="text" className="form-control" placeholder="Name" id="contact-name" name="contact-name"
                        required/>
                    </div>
                  </div>{/* <!-- /.col-lg-6  --> */}
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <i className="icon-email form-group-icon"></i>
                      <input type="email" className="form-control" placeholder="Email" id="contact-email"
                        name="contact-email" required/>
                    </div>
                  </div>{/* <!-- /.col-lg-6  --> */}
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <div className="form-group">
                      <i className="icon-phone form-group-icon"></i>
                      <input type="text" className="form-control" placeholder="Phone" id="contact-Phone"
                        name="contact-phone" required/>
                    </div>
                  </div>{/* <!-- /.col-lg-4  --> */}
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <div className="form-group form-group-date">
                      <i className="icon-calendar form-group-icon"></i>
                      <input type="date" className="form-control" id="contact-date" name="contact-date" required/>
                    </div>
                  </div>{/* <!-- /.col-lg-4  --> */}
                  <div className="col-sm-4 col-md-4 col-lg-4">
                    <div className="form-group form-group-date">
                      <i className="icon-clock form-group-icon"></i>
                      <input type="time" className="form-control" id="contact-time" name="contact-time" required/>
                    </div>
                  </div>{/* <!-- /.col-lg-4  --> */}
                  <div className="col-12">
                    <button type="submit" className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10">
                      <span>Book Appointment</span> <i className="icon-arrow-right"></i>
                    </button>
                    <div className="contact-result"></div>
                  </div>{/* <!-- /.col-lg-12  --> */}
                </div>{/* <!-- /.row  --> */}
              </form>
            </div>
          </div>{/* <!-- /.col-lg-7  --> */}
          <div className="col-sm-12 col-md-12 col-lg-5">
            <div className="heading heading-light mb-30">
              <h3 className="heading__title mb-30">Helping Patients From Around the Globe!!</h3>
              <p className="heading__desc">Our staff strives to make each interaction with patients clear, concise, and
                inviting. Support the important work of Medicsh Hospital by making a much-needed donation today.
              </p>
            </div>
            <div className="d-flex align-items-center">
              <a href="contact-us.html" className="btn btn__white btn__rounded mr-30">
                <i className="fas fa-heart"></i> <span>Make A Gift</span>
              </a>
              <a className="video__btn video__btn-white popup-video" href="https://www.youtube.com/watch?v=nrJtHemSPW4">
                <div className="video__player">
                  <i className="fa fa-play"></i>
                </div>
                <span className="video__btn-title color-white">Play Video</span>
              </a>
            </div>
            <div className="text__block">
              <p className="text__block-desc color-white font-weight-bold">We provide a comprehensive range of plans for
                families and individuals at every stage of life, with annual limits ranging from £1.5m to unlimited.</p>
              <div className="sinature color-white">
                <span className="font-weight-bold">Martin Qube</span><span>, HealthWalk Manager</span>
              </div>
            </div>{/* <!-- /.text__block  --> */}
            
          </div>{/* <!-- /.col-lg-5  --> */}
        </div>{/* <!-- /.row  --> */}
      </div>{/* <!-- /.container  --> */}
    </section>{/* <!-- /.contact layout 3  --> */}

    {/* <!-- ======================
      Blog Grid
    =========================  --> */}
    <section className="blog-grid pb-50">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6 offset-lg-3">
            <div className="heading text-center mb-40">
              <h2 className="heading__subtitle">Resource Library</h2>
              <h3 className="heading__title">Recent Articles</h3>
            </div>{/* <!-- /.heading  --> */}
          </div>{/* <!-- /.col-lg-6  --> */}
        </div>{/* <!-- /.row  --> */}
        <div className="row">
          {/* <!-- Post Item #1  --> */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <div className="post-item">
              <div className="post__img">
                <a href="blog-single-post.html">
                  <img src="../../assets/images/blog/sad-day.jpeg" alt="post image" loading="lazy"/>
                </a>
              </div>{/* <!-- /.post__img  --> */}
              <div className="post__body">
                <div className="post__meta-cat">
                  <a href="#">Mental Health</a>
                </div>{/* <!-- /.blog-meta-cat  --> */}
                <div className="post__meta d-flex">
                  <span className="post__meta-date">Jan 30, 2021</span>
                  <a className="post__meta-author" href="#">Robert Perrera</a>
                </div>
                <h4 className="post__title"><a href="#">6 Tips to Protect Your Mental Health When You’re Sick</a></h4>

                <p className="post__desc">It’s normal to feel anxiety, worry and grief any time you’re diagnosed with a
                  condition that’s certainly true if you test positive for COVID-19, or are presumed to be positive...
                </p>
                <a href="blog-single-post.html" className="btn btn__secondary btn__link btn__rounded">
                  <span>Read More</span>
                  <i className="icon-arrow-right"></i>
                </a>
              </div>{/* <!-- /.post__body  --> */}
            </div>{/* <!-- /.post-item  --> */}
          </div>{/* <!-- /.col-lg-4  --> */}
          {/* <!-- Post Item #2  --> */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <div className="post-item">
              <div className="post__img">
                <a href="blog-single-post.html">
                  <img src="../../assets/images/blog/Face-mask.jpeg" alt="post image" loading="lazy"/>
                </a>
              </div>{/* <!-- /.post__img  --> */}
              <div className="post__body">
                <div className="post__meta-cat">
                  <a href="#">Infectious</a><a href="#">Tips</a>
                </div>{/* <!-- /.blog-meta-cat  --> */}
                <div className="post__meta d-flex">
                  <span className="post__meta-date">Jun 30, 2021</span>
                  <a className="post__meta-author" href="#">Smriti Sengupta</a>
                </div>
                <h4 className="post__title"><a href="#">Unsure About Wearing a Face Mask? Here’s How and Why</a></h4>
                <p className="post__desc">That means that you should still be following any shelter-in-place orders in your
                  community. But when you’re venturing out to the grocery store, pharmacy or hospital..
                </p>
                <a href="blog-single-post.html" className="btn btn__secondary btn__link btn__rounded">
                  <span>Read More</span>
                  <i className="icon-arrow-right"></i>
                </a>
              </div>{/* <!-- /.post__body  --> */}
            </div>{/* <!-- /.post-item  --> */}
          </div>{/* <!-- /.col-lg-4  --> */}
          {/* <!-- Post Item #3  --> */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <div className="post-item">
              <div className="post__img">
                <a href="blog-single-post.html">
                  <img src="../../assets/images/blog/Eating-healthyWFH.jpg" alt="post image" loading="lazy"/>
                </a>
              </div>{/* <!-- /.post__img  --> */}
              <div className="post__body">
                <div className="post__meta-cat">
                  <a href="#">Life Style</a><a href="#">Nutrition</a>
                </div>{/* <!-- /.blog-meta-cat  --> */}
                <div className="post__meta d-flex">
                  <span className="post__meta-date">Feb 28, 2021</span>
                  <a className="post__meta-author" href="#">Vasudeva Chowhan</a>
                </div>
                <h4 className="post__title"><a href="#">Tips for Eating Healthy When You’re Working From Home </a></h4>

                <p className="post__desc">It’s normal to feel anxiety, worry and grief any time you’re diagnosed with a
                  condition that’s certainly true if you test positive for COVID-19, or are presumed to be positive...
                </p>
                <a href="blog-single-post.html" className="btn btn__secondary btn__link btn__rounded">
                  <span>Read More</span>
                  <i className="icon-arrow-right"></i>
                </a>
              </div>{/* <!-- /.post__body  --> */}
            </div>{/* <!-- /.post-item  --> */}
          </div>{/* <!-- /.col-lg-4  --> */}
        </div>{/* <!-- /.row  --> */}
      </div>{/* <!-- /.container  --> */}
    </section>{/* <!-- /.blog Grid  --> */}

    {/* <!-- ========================
      Footer
    ==========================  --> */}
    <footer className="footer">
      <div className="footer-primary">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-3">
              <div className="footer-widget-about">
                <img src={NavLogoFooter} alt="logo" className="mb-30" width="135px" height="76px"/>
                <p className="color-gray">Our goal is to deliver quality of care in a courteous, respectful, and
                  compassionate manner. We hope you will allow us to care for you and strive to be the first and best
                  choice for your family healthcare.
                </p>
                <a href="appointment.html" className="btn btn__primary btn__primary-style2 btn__link">
                  <span>Make Appointment</span> <i className="icon-arrow-right"></i>
                </a>
              </div>{/* <!-- /.footer-widget__content  --> */}
            </div>{/* <!-- /.col-xl-2  --> */}
            <div className="col-sm-6 col-md-6 col-lg-2 offset-lg-1">
              <div className="footer-widget-nav">
                <h6 className="footer-widget__title">Our Services</h6>
                <nav>
                  <ul className="list-unstyled">
                    <li><a href="#">For Doctors</a></li>
                    <li>  <a href="/doctor/home" className="home-button">Physicians</a></li>
                    <li><a href="#">For Patients</a></li>
                    <li><a href="#">For Laboratories</a></li>
                    <li><a href="#">For Researchers</a></li>
                    <li><a href="#">For Trainers</a></li>
                  </ul>
                </nav>
              </div>{/* <!-- /.footer-widget__content  --> */}
            </div>{/* <!-- /.col-lg-2  --> */}
            <div className="col-sm-6 col-md-6 col-lg-2">
              <div className="footer-widget-nav">
                <h6 className="footer-widget__title">Links</h6>
                <nav>
                  <ul className="list-unstyled">
                    <li><a href="#">About Us</a></li>
                    <li><a href="#">Our CLinic</a></li>
                    <li><a href="#">Our Doctors</a></li>
                    <li><a href="#">News & Media</a></li>
                    <li><a href="#">Appointments</a></li>
                  </ul>
                </nav>
              </div>{/* <!-- /.footer-widget__content  --> */}
            </div>{/* <!-- /.col-lg-2  --> */}
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="footer-widget-contact">
                <h6 className="footer-widget__title color-heading">Quick Contacts</h6>
                <ul className="contact-list list-unstyled">
                  <li>If you have any questions or need help, feel free to contact with our team.</li>
                  <li>
                      <a href="tel:+91-9073940606" className="phone__number">
                        <i className="icon-phone"></i> <span>+91-9073940606</span>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:+91-9073940606" className="phone__number">
                        <i className="icon-email"></i> <span>contactus@hlthtek.com</span>
                      </a>
                    </li>
                  <li className="color-body">Kolkata, West Bengal, India.</li>
                </ul>
                <div className="d-flex align-items-center">
                  <a href="#" className="btn btn__primary btn__link mr-30">
                    <i className="icon-arrow-right"></i> <span>Get Directions</span>
                  </a>
                  <ul className="social-icons list-unstyled mb-0">
                    <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                    <li><a href="#"><i className="fab fa-instagram"></i></a></li>
                    <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                  </ul>{/* <!-- /.social-icons  --> */}
                </div>
              </div>{/* <!-- /.footer-widget__content  --> */}
            </div>{/* <!-- /.col-lg-2  --> */}
          </div>{/* <!-- /.row  --> */}
        </div>{/* <!-- /.container  --> */}
      </div>{/* <!-- /.footer-primary  --> */}
      <div className="footer-secondary">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <span className="fz-14">&copy; 2021 Healthwalk, All Rights Reserved.</span>              
            </div>{/* <!-- /.col-lg-6  --> */}
            <div className="col-sm-12 col-md-6 col-lg-6">
              <nav>
                <ul className="list-unstyled footer__copyright-links d-flex flex-wrap justify-content-end mb-0">
                  <li><a href="#">Terms & Conditions</a></li>
                  <li><a href="#">Privacy Policy</a></li>
                  <li><a href="#">Cookies</a></li>
                  <li><a href="#">Version- V2</a></li>
                </ul>
              </nav>
            </div>{/* <!-- /.col-lg-6  --> */}
          </div>{/* <!-- /.row  --> */}
        </div>{/* <!-- /.container  --> */}
      </div>{/* <!-- /.footer-secondary  --> */}
    </footer>{/* <!-- /.Footer  --> */}
    <button id="scrollTopBtn"><i className="fas fa-long-arrow-alt-up"></i></button>

    <Helmet>
    <script src="/assets/js/jquery-3.5.1.min.js"></script>
  <script src="/assets/js/plugins.js"></script>
  <script src="/assets/js/main.js"></script>
    <script src=
"https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js" 
    type="text/javascript" />
     <link rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap"/>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.3/css/all.css"/>
 
  <link href="/assets/images/logo/logo-light-small.png" rel="icon"/>
    </Helmet>
   
 
{/* <!-- /.wrapper  --> */} 
  </div>
  
  );
}
export default Search;
